import { useMutation } from '@apollo/client';
import { Stack, Heading } from 'braid-design-system';

import REMOVE_PREFERENCES_DISTRICT from '../../queries/removePreferencesLocation';
import AddPreference from '../AddPreference/AddPreference';
import ListItem from '../ListItem/ListItem';

interface Props {
  districts: any[];
  refetch: () => void;
}

const PreferredLocation = ({ districts, refetch }: Props) => {
  const [removePreferencesLocation] = useMutation(REMOVE_PREFERENCES_DISTRICT);
  const removeLocation = (id: string) => () => {
    removePreferencesLocation({
      variables: {
        input: { id },
      },
    }).then(refetch);
  };
  return (
    <Stack space="medium">
      <Heading level="4">Location</Heading>

      {districts.length > 0 && (
        <Stack space="small">
          {districts.map(({ id, displayTitle }, k) => (
            <ListItem
              key={k}
              itemLabel={displayTitle}
              remove={removeLocation(id)}
            />
          ))}
        </Stack>
      )}

      <AddPreference preference="location" refetchAll={refetch} />
    </Stack>
  );
};

export default PreferredLocation;
